<dsp-content-card [types]="[ 'select', 'datepicker', 'datepicker' ]" [loading]="loading$ | async">
  <atlas-field-select [size]="(isMobile$ | async) ? sizeSmall : sizeMedium" [fullWidth]="(isMobile$ | async)"
    [style.--radius-xsmall]="'4px'" [widthValue]="270" *dsp-content-filter id="statements-select"
    [label]="'Select Option'" placeholder="Select" [multiselectable]="true" [options]="typesOptions"
    [showSelectAll]="true" [checkbox]="true" [clearable]="false" (valueChange)="onChangeType($event)"
    [(ngModel)]="type">
  </atlas-field-select>

  <atlas-field [size]="(isMobile$ | async) ? sizeSmall : sizeMedium" [fullWidth]="(isMobile$ | async)"
    [widthValue]="270" *dsp-content-filter>
    <atlas-field-label>From</atlas-field-label>
    <input [(ngModel)]="from" atlasInput [min]="'1900-01-01'" [max]="to" [Datepicker]="pickerFrom"
      [placeholder]="'Choose a date'" (dateChange)="onChangeFrom($event)" [readonly]="true" />
    <atlas-field-suffix>
      <datepicker-toggle [datepicker]="pickerFrom"></datepicker-toggle>
    </atlas-field-suffix>
    <datepicker #pickerFrom> </datepicker>
  </atlas-field>


  <atlas-field [size]="(isMobile$ | async) ? sizeSmall : sizeMedium" [fullWidth]="(isMobile$ | async)"
    [widthValue]="270" *dsp-content-filter>
    <atlas-field-label>To</atlas-field-label>
    <input [(ngModel)]="to" atlasInput [min]="from" [Datepicker]="pickerTo" [placeholder]="'Choose a date'"
      (dateChange)="onChangeTo($event)" [readonly]="true" />
    <atlas-field-suffix>
      <datepicker-toggle [datepicker]="pickerTo"></datepicker-toggle>
    </atlas-field-suffix>
    <datepicker #pickerTo> </datepicker>
  </atlas-field>


  <div dsp-content>
    <div class="row" *ngIf="!(isMobile$ | async)">
      <div class="columns">
        <div class="dsp-title-container">
          <!-- <atlas-icon [icon]="'subtitles'" size="large" color="primary" [alt]="'Statements'">
          </atlas-icon> -->
          <atlas-icon class='statements-icon' [icon]="'icon-webpage-24'" [size]="'large'" [alt]="'Statements'">
          </atlas-icon>
          <h3 class="mos-u-spacer--margin-none mos-u-spacer--padding-left-sm">
            Statements
          </h3>
          <atlas-icon *ngIf="(notes$ | async)?.statements !== undefined"
            class="mos-u-spacer--margin-left-xxsm dsp-statements-tooltip-trigger" [haloTooltipWithArrow]="true"
            [haloTooltip]="(notes$ | async)?.statements" [haloTooltipPosition]="'right'" [haloTooltipShowDelay]="100"
            [id]="'statements-note-icon'" [size]="'small'" [icon]="'c-info'" [collection]="'user-interface'"
            [alt]="'info'">
          </atlas-icon>
        </div>


      </div>
      <div class="columns shrink" [style.margin-left]="'auto'">
        <atlas-dropdown #statementsDropdown="atlasDropdown" [id]="'toggle-statements-export'" [icon]="'more_vert'"
          [placement]="dropdownPlacementLeftStart" [iconSize]="sizeMedium" [iconButtonAlt]="'More options'"
          [iconAriaTitle]="'More options'" [triggerType]="dropdownTriggerTypeIconButton">
          <atlas-menu [style.display]="'block'" [style.max-width]="'fit-content'">
            <atlas-menu-item (click)="statementsDropdown.menu?.closeMenu($event); onDownloadZip()">
              <a [id]="'download-button'">
                Download Statements
              </a>
            </atlas-menu-item>
          </atlas-menu>
        </atlas-dropdown>
      </div>
    </div>

    <ng-container *ngIf="!(isMobile$ | async)">
      <atlas-table class="dsp-statement" [customSort]="true">

        <thead atlas-table-header #header>

          <tr atlas-table-row>

            <th atlas-table-header-cell *ngFor="let col of headers" [columnDef]="col"
              (click)="onSort(col.fieldKey,header.sortOption.direction)">
              <span [ngClass]="{ 'mos-u-text-right': col.displayLabel === 'Action' }">
                {{ col.displayLabel }}
              </span>
            </th>
          </tr>
        </thead>
        <tbody atlas-table-body class="dsp-statement-table-body">
          <tr halo-table-row *ngFor="let row of statements$ | async">
            <td atlas-table-cell [ngClass]="{ 'mos-u-text-center': !row.date }">
              {{ row.date ? row.date : '-' }}
            </td>
            <td atlas-table-cell [ngClass]="{ 'mos-u-text-center': !row.subtype }">
              {{ row.subtype ? row.subtype : '-' }}
            </td>
            <td atlas-table-cell [ngClass]="{ 'mos-u-text-center': !row.account }">
              <span class="dsp-account-cell" [haloTooltip]="row.account || ''" [haloTooltipWithArrow]="true"
                haloTooltipPosition="bottom">
                {{ row.account ? row.account : '-' }}
              </span>
            </td>
            <td atlas-table-cell class="mos-u-text-right">
              <button>
                <atlas-icon [icon]="'download'" [size]="'large'" (click)="onExportPDF(row)"></atlas-icon>
              </button>
            </td>

          </tr>
        </tbody>
      </atlas-table>
      <div class="mos-u-spacer--margin-top-sm row">
        <div *ngIf="(statements$ | async)?.length" class="column medium-3 pagination-container"
          style="justify-content: left;">
          <span>
            Showing {{
            (((pagination$ | async)?.page - 1) * (pagination$ | async)?.itemsByPage + 1)
            }} to {{
            getMin((pagination$ | async)?.page * (pagination$ | async)?.itemsByPage, (pagination$ | async)?.total)
            }} of {{ (pagination$ | async)?.total }} entries
          </span>
        </div>
        <atlas-pagination *ngIf="(pagination$ | async)?.total" (paginationInfoRequest)="onPaginate($event)"
          [paginationInfo]="pagination$ | async" [showLimitOptions]="true">
        </atlas-pagination>
      </div>
    </ng-container>
  </div>
</dsp-content-card>